import { Component, inject } from '@angular/core';

import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { MagayaEntity } from '@qwyk/hub/administration/data-access/customer-users';

@Component({
    selector: 'qwyk-search-magaya-entity-modal',
    templateUrl: './search-magaya-entity-modal.component.html',
    styleUrls: ['./search-magaya-entity-modal.component.scss'],
})
export class SearchMagayaEntityModalComponent {

    protected dialogRef = inject(DynamicDialogRef);

    public onSelectEntity(magayaEntity: MagayaEntity): void {
        this.dialogRef.close(magayaEntity);
    }

    public onCancel(): void {
        this.dialogRef.close();
    }
}
